module.exports = __webpack_public_path__ + "static/media/tomFamily.266bf8bb.png";